import * as ko from 'knockout';

/**
 * create a binding for the main embed element;
 * this will create all sub-components in turn
 */
export function bindEmbedElement()
{
    ko.applyBindings(this, document.getElementById('edf-power-patrol-embed'));
}


// WEBPACK FOOTER //
// ./src/ts/embed/BindEmbed.ts